import { API_URL } from './config'
import { userStore } from './stores'

export async function requestApi(url, options) {
  // const token = localStorage.getItem('x-access-token')
  const res = await fetch(`${API_URL}${url}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      'Content-Type': 'application/json',
      Authorization: userStore.token || '',
    },
  })

  // parse response body
  const data = await res.json()
  // console.log("--",data)
  if (data.data === 'Invalid Token') {
    userStore.signOut();
  }
  if (
    !res.ok &&
    (res.status === 401 || res.status === 403 || res.status === 400)
  ) {
    // if request unaithorized, sign user out
    console.debug('unauthorized request');

    userStore.signOut();
  }

  // if error, throw it
  if (!res.ok) {
    throw data
  }

  // if ok, return token
  return data
}

export async function requestFormData(url, formData) {
  const res = await fetch(`${API_URL}${url}`, {
    method: 'POST',
    headers: {
      Authorization: userStore.token || '',
    },
    body: formData,
  });

  const data = await res.json();

  if (data.data === 'Invalid Token') {
    userStore.signOut();
  }

  if (
    !res.ok &&
    (res.status === 403)
  ) {
    console.debug('unauthorized request');
    userStore.signOut();
  }

  if (!res.ok) {
    throw data;
  }

  return data;
}

export async function requestPutFormData(url, formData) {
  const res = await fetch(`${API_URL}${url}`, {
    method: 'PUT',
    headers: {
      Authorization: userStore.token || '',
    },
    body: formData,
  });

  const data = await res.json();

  if (data.data === 'Invalid Token') {
    userStore.signOut();
  }

  if (
    !res.ok &&
    (res.status === 403)
  ) {
    console.debug('unauthorized request');
    userStore.signOut();
  }

  if (!res.ok) {
    throw data;
  }

  return data;
}
